import posthog from 'posthog-js';
import { useCallback } from 'react';
import { useAppSelector } from '../reduxHook';
import GetRealm from '@acorn-portal/shared/src/utils/getRealm';
import { safelyConsoleError } from '@acorn-portal/shared/src/utils/safely-console-error';

interface IOptions {
	[key: string]: unknown;
}

const realm = GetRealm();

const useTrack = (options?: IOptions) => {
	const fullPolicy = useAppSelector((state) => state.fullPolicy);
	const { policyNumber, product, coverDetails } = fullPolicy;

	const track = useCallback(
		(event: string, properties: Record<string, unknown> = {}) => {
			const props = {
				policyNumber,
				product,
				coverType: coverDetails?.coverType,
				realm,
				...properties,
			};
			posthog.capture(event, props);
			safelyConsoleError(event, props); //leaving this in for now
		},
		[options, policyNumber, product, coverDetails],
	);

	return { track };
};

export default useTrack;
